module.exports = __webpack_public_path__ + "img/mobile-screen-button.1e3fe0ad.svg";